<template>
  <vue-modal :active="active" type="small" @closed="$emit('closed')">
    <vue-filters @applied="$modal.close('products-filters')">
      <h3 class="border-b border-gray-lighter pb-2 mb-4">Filtrer</h3>
      <div class="mb-8">
        <div class="flex items-center mb-2">
          <span class="w-1/3 mr-2">Statut</span>
          <vue-filter param="active" :options="filterActiveOptions"/>
        </div>
        <div class="flex items-center">
          <span class="w-1/3 mr-2">Famille</span>
          <vue-filter-family param="families" track-by="id" multiple/>
        </div>
      </div>
      <h3 class="border-b border-gray-lighter pb-2 mb-4">Trier</h3>
      <div>
        <div class="flex items-center mb-2">
          <span class="w-1/3 mr-2">Nom</span>
          <vue-filter param="sortName" />
        </div>
        <div class="flex items-center">
          <span class="w-1/3 mr-2">Stock</span>
          <vue-filter param="sortStock" />
        </div>
      </div>
    </vue-filters>
  </vue-modal>
</template>

<script>
import modal from '../../mixins/modal';
import VueFilters from '../filters/Filters.vue';
import VueFilter from '../filters/Filter.vue';
import VueFilterFamily from '../filters/FilterFamily.vue';

export default {
  components: { VueFilters, VueFilter, VueFilterFamily },

  mixins: [modal],

  computed: {
    filterActiveOptions() {
      return [{ label: 'Actif', value: '1' }, { label: 'Inactif', value: '0' }];
    },
  },
};
</script>
